import "../calendar_common_service";
import * as rails_controller from "./rails_controller_request";

const EXCLUDE_CALENDAR = ["birthdays", "birthday", "holidays", "holiday"];
let calendar_service = "";
let eventBody = "";
let get_attendees_data = "";
export const upload_calendar_event = (calendar_data) => {
  calendar_service =
    document.querySelector(".crm_calendar").dataset.calendarServiceValue;
  if (["Google", "Microsoft"].includes(calendar_service)) {
    const { calendarData, attendees } = calendar_data;
    console.log("calendarData", calendarData);
    console.log("attendees", attendees);
    const options = {
      defaultView: "month",
      calendars: calendarData,
      month: {
        workweek: false,
      },
      week: {},
      useFormPopup: true,
      useDetailPopup: true,
      usageStatistics: true,
      template: {
        milestone: function (model) {
          return (
            '<span class="calendar-font-icon ic-milestone-b"></span> <span style="background-color: ' +
            model.bgColor +
            '">' +
            model.title +
            "</span>"
          );
        },
        allday: function (schedule) {
          return getTimeTemplate(schedule, true);
        },
        time: function (schedule) {
          return getTimeTemplate(schedule, false);
        },
        popupDetailBody: function (model) {
          return model.body;
        },
      },
    };

    console.log("options", options);
    const toastCalendar = new Calendar("#toastCalendar", options);
    // console.log('toastCalendar', toastCalendar )

    toastCalendar.on({
      clickEvent: function (e) {
        console.log("clickEvent", e);
        setTimeout(() => {
          let calendarEdit = document.querySelector(
            ".toastui-calendar-edit-button",
          );
          console.log("calendarEdit", calendarEdit);
          eventBody = e.event.body;
          console.log("calendarBody", eventBody);
          if (calendarEdit != null) {
            let get_attendees = document.querySelector(
              ".toastui-calendar-template-popupDetailAttendees",
            );
            if (get_attendees != "" && get_attendees != undefined) {
              get_attendees_data = get_attendees.textContent;
            }
            calendarEdit.addEventListener("click", (evt) => {
              console.log("click event edit clicked");
              console.log(eventBody);
              console.log("calendarData", calendarData);
              console.log("attendees", attendees);
              setTimeout(() => {
                let calendarBody = document.querySelector(
                  ".toastui-calendar-content-body",
                );
                if (calendarBody != undefined && calendarBody != "") {
                  calendarBody.innerHTML = eventBody;
                }
                eventBody = "";
              }, 10);
            });
          }
        }, 4);
      },
      clickMore: function (e) {
        console.log("clickMore", e);
      },
      clickMoreEventsBtn: function (e) {
        console.log("clickMoreEventsBtn", e);
      },
      clickDayname: function (date) {
        console.log("clickDayname", date);
      },
      beforeCreateEvent: function (event) {
        // update attendees
        let attendees = document.querySelector("#attendees");
        let get_attendees = [...attendees.selectedOptions].map(
          (option) => option.value,
        );
        event.attendees = get_attendees;
        console.log("beforeCreateEvent", event);
        saveNewSchedule(event);
      },
      beforeUpdateEvent: function ({ event, changes }) {
        const calendar = calendarData.find((cd) => {
          return cd.id == event.calendarId;
        });
        let attendees = [];
        let get_search_choice = document.querySelectorAll(".search-choice");
        if (get_search_choice.length > 0) {
          get_search_choice.forEach((gsc) => {
            attendees.push(gsc.innerText);
          });
          changes.attendees = attendees;
        }
        changes.title =
          changes.title == undefined ? event.title : changes.title;
        changes.body = changes.body == undefined ? event.body : changes.body;
        changes.location =
          changes.location == undefined ? event.location : changes.location;
        changes.title =
          changes.title == undefined ? event.title : changes.title;
        changes.start =
          changes.start == undefined ? event.start : changes.start;
        changes.end = changes.end == undefined ? event.end : changes.end;
        changes.isAllday =
          changes.isAllday == undefined ? event.isAllday : changes.isAllday;
        changes.category = changes.isAllday ? "allday" : "milestone";
        if (calendar) {
          changes.calendarId = calendar.id;
          changes.color = "#000000";
          changes.backgroundColor = calendar.backgroundColor;
          changes.dragBackgroundColor = calendar.dragBackgroundColor;
          changes.borderColor = calendar.borderColor;
        }
        if (!changes.isAllday) {
          changes.color = calendar.backgroundColor;
          changes.backgroundColor = "transparent";
          changes.dragBackgroundColor = "transparent";
          changes.borderColor = "transparent";
        }
        console.log("beforeUpdateEvent", event);
        console.log("beforeUpdateChanges", changes);
        const { id, calendarId } = event;
        toastCalendar.updateEvent(id, calendarId, changes);
        rails_controller.update_event({
          calendarId: calendarId,
          id: id,
          changes: changes,
          type: "update_event",
          service: calendar_service,
        });
      },
      beforeDeleteEvent: function (event) {
        console.log("beforeDeleteEvent", event);
        const { id, calendarId } = event;
        toastCalendar.deleteEvent(id, calendarId);
        rails_controller.delete_event({
          calendarId: calendarId,
          id: id,
          type: "delete_event",
          service: calendar_service,
        });
      },
      afterRenderEvent: function (e) {
        console.log("afterRenderEvent");
        const schedule = e.schedule;
      },
      clickTimezonesCollapseBtn: function (timezonesCollapsed) {
        console.log("timezonesCollapsed", timezonesCollapsed);

        if (timezonesCollapsed) {
          toastCalendar.setTheme({
            "week.daygridLeft.width": "77px",
            "week.timegridLeft.width": "77px",
          });
        } else {
          toastCalendar.setTheme({
            "week.daygridLeft.width": "60px",
            "week.timegridLeft.width": "60px",
          });
        }

        return true;
      },
    });

    const prevCalendar = document.querySelector("#prevCalendar");
    const nextCalendar = document.querySelector("#nextCalendar");
    const calendar_month = document.querySelector("#calendar_month");
    const formPopup = document.querySelector(
      ".toastui-calendar-event-form-popup-slot",
    );

    formPopup.addEventListener("DOMNodeInserted", (evt) => {
      if (
        evt.target.classList != undefined &&
        evt.target.classList.value.includes("toastui-calendar-popup-container")
      ) {
        console.log("formPopup", evt.target.classList);
        addingElementInFormPopup();
      }
    });

    const addingElementInFormPopup = () => {
      let getCalendarDom = document.querySelector(
        ".toastui-calendar-popup-section-location",
      );
      let calendarClosest = getCalendarDom.closest(
        ".toastui-calendar-form-container",
      );
      let calendarMenuContent = document.querySelector(
        ".toastui-calendar-popup-button",
      );
      let state_section = document.querySelector(
        ".toastui-calendar-state-section",
      );
      state_section.style.display = "none";
      let checkSaveMenu = document.querySelector(
        ".toastui-calendar-template-popupSave",
      );
      if (checkSaveMenu != undefined) {
        console.log("ratan", checkSaveMenu);
        let get_present_menu = document.querySelector(
          ".toastui-calendar-event-calendar",
        );
        get_present_menu.click();
        setTimeout(() => {
          let getCalendarMenuArray = [];
          let set_present_menu = document.querySelectorAll(
            ".toastui-calendar-dropdown-menu-item",
          );
          set_present_menu.forEach((spm) => {
            if (
              !spm.textContent.toLowerCase().includes(EXCLUDE_CALENDAR[0]) &&
              !spm.textContent.toLowerCase().includes(EXCLUDE_CALENDAR[1]) &&
              !spm.textContent.toLowerCase().includes(EXCLUDE_CALENDAR[2]) &&
              !spm.textContent.toLowerCase().includes(EXCLUDE_CALENDAR[3])
            ) {
              getCalendarMenuArray.push(spm);
            }
          });
          getCalendarMenuArray[0].click();
        }, 1);
      }

      calendarMenuContent.addEventListener("click", (evt) => {
        setTimeout(() => {
          let calendarMenu = document.querySelector(
            ".toastui-calendar-dropdown-menu",
          );
          let checkUpdateMenu = document.querySelector(
            ".toastui-calendar-template-popupUpdate",
          );
          if (calendarMenu != undefined && calendarMenu != "") {
            let calendarMenuArray = [];
            calendarMenu.children.forEach((cm) => {
              let check_content = cm.querySelector(".toastui-calendar-content");
              EXCLUDE_CALENDAR.forEach((ecl) => {
                if (check_content.textContent.toLowerCase().includes(ecl)) {
                  calendarMenuArray.push(cm);
                }
              });
            });
            let remove_duplicates = [...new Set(calendarMenuArray)];
            remove_duplicates.forEach((rd) => rd.remove());
          }
          if (checkUpdateMenu != undefined && calendarMenu != undefined) {
            let calendarMenuArray = [];
            let present_menu = document.querySelector(
              ".toastui-calendar-event-calendar",
            ).textContent;
            calendarMenu.children.forEach((cm) => {
              let check_content = cm.querySelector(
                ".toastui-calendar-content",
              ).textContent;
              if (check_content != present_menu) {
                calendarMenuArray.push(cm);
              }
            });
            let remove_duplicates = [...new Set(calendarMenuArray)];
            remove_duplicates.forEach((rd) => rd.remove());
          }
        }, 1);
      });
      console.log(calendarMenuContent);
      setTimeout(() => {
        let addAttendessArray = [];
        addAttendessArray.push(
          '<div class="toastui-calendar-popup-section-manual">',
        );
        addAttendessArray.push('<div class="form-group">');
        addAttendessArray.push(
          '<label for="attendees" style="display:block;">Choose attendees:</label>',
        );
        addAttendessArray.push(
          '<select name="attendees" class="form-control chosen" multiple="multiple" id="attendees">',
        );
        attendees.forEach((att) => {
          addAttendessArray.push(`<option value=${att}>${att}</option>`);
        });
        if (get_attendees_data != "") {
          get_attendees_data.split(",").forEach((gtd) => {
            addAttendessArray.push(
              `<option value=${gtd} selected>${gtd}</option>`,
            );
          });
          get_attendees_data = "";
        }
        addAttendessArray.push("</select></div></div>");
        calendarClosest.children[1].insertAdjacentHTML(
          "beforebegin",
          addAttendessArray.join(""),
        );
        setTimeout(initChosen, 10);
      }, 3);

      // calendar body
      setTimeout(() => {
        let addBodyArray = [];
        addBodyArray.push(
          '<div class="toastui-calendar-popup-section-manual" style="margin-top: 5px;">',
        );
        addBodyArray.push(
          '<textarea name="body" class="toastui-calendar-content-body" placeholder="Body" cols="67"></textarea>',
        );
        addBodyArray.push("</div>");
        calendarClosest.children[2].insertAdjacentHTML(
          "beforebegin",
          addBodyArray.join(""),
        );
      }, 2);
    };

    prevCalendar.addEventListener("click", (evt) => {
      toastCalendar.prev();
      updateCalendarYear("prev");
    });

    nextCalendar.addEventListener("click", (evt) => {
      toastCalendar.next();
      updateCalendarYear("next");
    });

    const updateCalendarYear = (type) => {
      let date = new Date(calendar_month.textContent);
      switch (type) {
        case "prev":
          date.setMonth(date.getMonth() - 1);
          break;
        case "next":
          date.setMonth(date.getMonth() + 1);
          break;
      }
      calendar_month.textContent = `${date.toLocaleString("en-us", { month: "long" })} ${date.getFullYear()}`;
    };

    const setSchedules = () => {
      toastCalendar.clear();
      rails_controller.get_event_list(
        "get_events",
        toastCalendar,
        calendar_service,
      );
    };

    function saveNewSchedule(scheduleData) {
      const calendar = calendarData.find((cd) => {
        return cd.id == scheduleData.calendarId;
      });
      const schedule = {
        id: String(chance.guid()),
        attendees: scheduleData.attendees,
        title: scheduleData.title,
        body: scheduleData.body,
        isAllday: scheduleData.isAllday,
        start: scheduleData.start,
        end: scheduleData.end,
        category: scheduleData.isAllday ? "allday" : "milestone",
        isPrivate: scheduleData.isPrivate,
        dueDateClass: "",
        color: "#000000",
        bgColor: calendar.bgColor,
        dragBgColor: calendar.bgColor,
        borderColor: calendar.borderColor,
        location: scheduleData.location,
        state: scheduleData.state,
      };
      if (calendar) {
        schedule.calendarId = calendar.id;
        schedule.color = schedule.color;
        schedule.backgroundColor = calendar.backgroundColor;
        schedule.dragBackgroundColor = calendar.dragBackgroundColor;
        schedule.borderColor = calendar.borderColor;
      }
      if (!scheduleData.isAllday) {
        schedule.color = calendar.backgroundColor;
        schedule.backgroundColor = "transparent";
        schedule.dragBackgroundColor = "transparent";
        schedule.borderColor = "transparent";
      }
      rails_controller.create_event({
        event: schedule,
        toastCalendar: toastCalendar,
        type: "create_event",
        service: calendar_service,
      });
    }

    const getTimeTemplate = (schedule, isAllDay) => {
      const html = [];
      const start = moment(new Date(schedule.start).toUTCString());
      const {
        title,
        isPrivate,
        isReadOnly,
        recurrenceRule,
        attendees,
        location,
      } = schedule;

      if (!isAllDay) {
        html.push(`<strong>${start.format("HH:mm")}</strong>`);
      }
      if (isPrivate) {
        html.push('<span class="calendar-font-icon ic-lock-b"></span>');
        html.push(" Private");
      } else {
        if (isReadOnly) {
          html.push('<span class="calendar-font-icon ic-readonly-b"></span>');
        } else if (recurrenceRule) {
          html.push('<span class="calendar-font-icon ic-repeat-b"></span>');
        } else if (attendees.length) {
          html.push('<span class="calendar-font-icon ic-user-b"></span>');
        } else if (location) {
          html.push('<span class="calendar-font-icon ic-location-b"></span>');
        }
        html.push(` ${title}`);
      }

      return html.join("");
    };

    setSchedules();
  }
};
